import { API } from 'aws-amplify'
import { getUserID } from '../components/auth/auth'

// LogRocket disabled - using Sentry instead
// const LogRocket = require('logrocket')
import * as Sentry from "@sentry/gatsby"

// Helper to capture errors in Sentry (replaces LogRocket)
const captureError = (error, context = {}) => {
  if (typeof window !== 'undefined' && typeof Sentry !== 'undefined') {
    console.error('[ANALYTICS ERROR]', error, context);
    Sentry.captureException(error, {
      tags: {
        source: 'analytics',
        ...context.tags
      },
      extra: {
        ...context.extra,
        errorMessage: error?.message,
        errorStack: error?.stack
      },
      level: 'error'
    });
  } else {
    console.error('[ANALYTICS ERROR] Sentry not available!', error);
  }
}
const aa = require('search-insights')

const isSSR = typeof window === "undefined"

const gtag = () => {
  window.dataLayer.push(arguments)
}

const createProductFromItems = (items) => {
  var products = []
  var price = 0
  items.forEach(item => {
    products.push(createProductFromItem(item))
    price = price + (Number(item.price) * Number(item.quantity))
  })
  return {
    items: products,
    price
  }
}

const sendInsight = (eventName, item) => {
  try {
    if (isSSR) return

    // Initialize Algolia insights if not already initialized
    if (!window.algoliaInsightsInitialized) {
      const appId = process.env.GATSBY_ALGOLIA_APP_ID
      const searchKey = process.env.GATSBY_ALGOLIA_SEARCH_KEY
      if (appId && searchKey) {
        aa("init", {
          appId: appId,
          apiKey: searchKey,
        })
        window.algoliaInsightsInitialized = true
      }
    }

    // Check for metadata with search info (from Algolia search results)
    if (item && item.metadata && item.metadata.searchObjectID && item.metadata.searchQueryID) {
      aa('convertedObjectIDsAfterSearch', {
        userToken: getUserID(),
        eventName: eventName,
        index: process.env.GATSBY_ALGOLIA_INDEX_NAME,
        queryID: item.metadata.searchQueryID,
        objectIDs: [item.metadata.searchObjectID]
      })
    }
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Send Insight to Algolia", e)
  }
}

const createProductFromItem = (item) => {
  var itemToAdd = {
    item_id: item.sku,
    item_name: item.title,
    item_brand: 'INGMARSON',
    currency: 'GBP',
    price: Number(item.price),
    quantity: item.quantity ? Number(item.quantity) : 1,
  }

  if (item.metadata && item.metadata.itemLocation && item.metadata.collection) {
    itemToAdd['index'] = item.metadata.itemLocation
    itemToAdd['item_list_name'] = item.metadata.collection
    itemToAdd['item_list_id'] = item.metadata.collection
  }
  return itemToAdd
}

const sendCartEvent = (eventAction) => {
  try {
    gtag('event', eventAction)
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Error", e)
  }
}

const sendCartItemEvent = (items, eventData, action, eventAction) => {
  try {
    gtag('event', action, eventData)
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Error", e)
  }
}

const sendCartAnalyticsEvent = (item, action, eventAction) => {
  try {
    const product = createProductFromItem(item)
    sendCartItemEvent([product], {
      currency: "GBP",
      discount: 0.00,
      value: Number(product.price * product.quantity),
      items: [product],
    }, action, eventAction)
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
  }
}

const informBackend = (type, webhookData) => {
  try {
    const data = {
      body: {
        type: type,
        data: webhookData
      },
      headers: {
        "Content-Type": "application/json"
      }
    }
    API
      .post('api', '/snipcartClient', data)
      .then(response => {
        console.log("INFORM BACKEND COMPLETE", response)
      })
      .catch(error => {
        console.error("INFORM BACKEND ERROR", error);
        // Capture API error to Sentry
        captureError(error, {
          tags: {
            function: 'informBackend',
            endpoint: '/snipcartClient',
            type: type
          },
          extra: {
            type: type,
            webhookData: webhookData,
            errorResponse: error?.response,
            errorMessage: error?.message,
            errorStack: error?.stack
          }
        });
      })
  } catch (e) {
    captureError(e, {
      tags: {
        function: 'informBackend',
        endpoint: '/snipcartClient'
      },
      extra: {
        type: type,
        webhookData: webhookData
      }
    })
  }
}

export const itemRemoved = (item) => {
  try {
    sendCartAnalytics(item, 'remove_from_cart', 'Item Removed from Cart')
    sendInsight('Item Removed from Cart', item)
    informBackend("ITEM_REMOVED", item)
  } catch (e) {
    captureError(e, { tags: { function: 'itemRemoved' } });
    console.error("FAILED TO REMOVE ITEM", e)
  }
}

export const sendCartAnalytics = (item, action, eventAction) => {
  try {
    const product = createProductFromItem(item)
    sendCartItemEvent([product], {
      currency: "GBP",
      discount: 0.00,
      value: Number(product.price * product.quantity),
      items: [product],
    }, action, eventAction)
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Error", e)
  }
}

export const cartOpened = (store) => {
  try {
    var products = store.cartProducts || []

    var { items, price } = createProductFromItems(products)
    sendCartItemEvent(items, {
      currency: "GBP",
      discount: 0.00,
      value: Number(price),
      items: items,
    }, 'view_cart', "VIEW CART")
    informBackend("CART_OPENED", items)
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Cart Open", e)
  }
}

export const checkoutOpened = (store) => {
  try {
    var products = store.cartProducts || []

    var { items, price } = createProductFromItems(products)
    sendCartItemEvent(items, {
      currency: "GBP",
      discount: 0.00,
      value: Number(price),
      items: items,
    }, 'begin_checkout', "CHECKOUT OPENED")
    informBackend("CHECKOUT_OPENED", items)
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Checkout Open", e)
  }
}

export const paymentOpened = (store) => {
  try {
    var products = store.cartProducts || []

    var { items, price } = createProductFromItems(products)
    sendCartItemEvent(items, {
      currency: "GBP",
      discount: 0.00,
      value: Number(price),
      items: items,
    }, 'add_payment_info', "PAYMENT OPENED")
    informBackend("PAYMENT_OPENED", items)
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Payment Open", e)
  }
}

const cartClosed = () => {
  try {
    var snipcartState = Snipcart.store.getState()
    var products = snipcartState.cart.items.items
    var { items, price } = createProductFromItems(products)
    sendCartItemEvent(items, {
      currency: "GBP",
      discount: 0.00,
      value: Number(price),
      items: items,
    }, 'cart_closed', "CART CLOSED")
    informBackend("CART_CLOSED", {})
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Cart Open", e)
  }
}

export const discountApplied = (store, discountValue) => {
  try {
    var products = store.cartProducts || []

    if (products.length === 0) {
      return
    }

    var { items, price } = createProductFromItems(products)
    sendCartItemEvent(items, {
      discount: discountValue || 0,
      currency: "GBP",
      value: Number(price),
      items: items,
    }, 'discount_applied', "DISCOUNT APPLIED")
    informBackend("DISCOUNT_APPLIED", { discount: discountValue })

  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log DISCOUNT", e)
  }
}

export const paymentFailed = (store, error) => {
  try {
    var products = store.cartProducts || []

    var { items, price } = createProductFromItems(products)
    sendCartItemEvent(items, {
      error: error,
      currency: "GBP",
      value: Number(price),
      discount: 0.00,
      items: items,
    }, 'payment_failed', "PAYMENT FAILED")

    informBackend("PAYMENT_FAIL", { error: error, items: items })

  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Payment Failed", e)
  }
}

const orderError = (error) => {
  try {
    console.log("ORDer eRROR", error)
    var snipcartState = Snipcart.store.getState()
    var products = snipcartState.cart.items.items

    var { items, price } = createProductFromItems(products)
    sendCartItemEvent(items, {
      error: error,
      discount: 0.00,
      currency: "GBP",
      value: Number(price),
      items: items,
    }, 'order_error', "ORDER ERROR")
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Error", e)
  }
}

export const orderCompleted = (order) => {
  console.log("ORDER COMPLETED", order)
  console.log("ORDER ITEMS", order)
  try {
    var { items } = createProductFromItems(order.items)
    var coupon = ""
    var discount = 0
    if (order.discounts && order.discounts.items && order.discounts.items.length > 0) {
      var discountItem = order.discounts.items[0]
      coupon = discountItem.code
      discount = Math.abs(discountItem.value)
    }
    sendCartItemEvent(items, {
      transaction_id: order.token,
      coupon: coupon,
      discount: Number(order.totals.discount),
      currency: "GBP",
      value: Number(order.totals.amount),
      shipping: Number(order.totals.shipping),
      items: items,
      order: order
    }, 'purchase', "ORDER COMPLETE")
    gtag('set', 'user_data', {
      "email": order.email ? order.email : "",
      "address": {
        "street": order.shipping.address1 ? order.shipping.address1 : "",
        "city": order.shipping.city ? order.shipping.city : "",
        "postal_code": order.shipping.zip ? order.shipping.zip : "",
        "country": order.shipping.country ? order.shipping.country : "",
      }
    })
  } catch (e) {
    captureError(e, { tags: { function: 'sendInsight' } })
    console.log("FAILED TO Log Order Complete", e)
  }
}

export const itemUpdated = (item) => {
  sendCartAnalytics(item, 'update', 'Item Updated in Cart')
}

export const itemAdded = async (item) => {
  try {
    sendCartAnalytics(item, 'add_to_cart', 'Item Added to Cart')
    sendInsight('Item Added to Cart', item)
    informBackend("ITEM_ADDED", item)
  } catch (e) {
    captureError(e, { tags: { function: 'itemAdded' } });
    console.error("STRIPE ANALYTICS FAILED TO ADD ITEM", e)
  }
}